/**
 * @flow
 * @relayHash 400c1af283e835d52700f8a67b70159b
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type AddReminderForEventWhenExpiredInput = {|
  token: string
|};
export type AddReminderForEventWhenExpiredMutationVariables = {|
  input: AddReminderForEventWhenExpiredInput
|};
export type AddReminderForEventWhenExpiredMutationResponse = {|
  +addReminderForEventWhenExpired: ?{|
    +status: ?string
  |}
|};
export type AddReminderForEventWhenExpiredMutation = {|
  variables: AddReminderForEventWhenExpiredMutationVariables,
  response: AddReminderForEventWhenExpiredMutationResponse,
|};
*/


/*
mutation AddReminderForEventWhenExpiredMutation(
  $input: AddReminderForEventWhenExpiredInput!
) {
  addReminderForEventWhenExpired(input: $input) {
    status
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "input",
    "type": "AddReminderForEventWhenExpiredInput!",
    "defaultValue": null
  }
],
v1 = [
  {
    "kind": "LinkedField",
    "alias": null,
    "name": "addReminderForEventWhenExpired",
    "storageKey": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "AddReminderForEventWhenExpiredPayload",
    "plural": false,
    "selections": [
      {
        "kind": "ScalarField",
        "alias": null,
        "name": "status",
        "args": null,
        "storageKey": null
      }
    ]
  }
];
return {
  "kind": "Request",
  "fragment": {
    "kind": "Fragment",
    "name": "AddReminderForEventWhenExpiredMutation",
    "type": "RootMutationType",
    "metadata": null,
    "argumentDefinitions": (v0/*: any*/),
    "selections": (v1/*: any*/)
  },
  "operation": {
    "kind": "Operation",
    "name": "AddReminderForEventWhenExpiredMutation",
    "argumentDefinitions": (v0/*: any*/),
    "selections": (v1/*: any*/)
  },
  "params": {
    "operationKind": "mutation",
    "name": "AddReminderForEventWhenExpiredMutation",
    "id": null,
    "text": "mutation AddReminderForEventWhenExpiredMutation(\n  $input: AddReminderForEventWhenExpiredInput!\n) {\n  addReminderForEventWhenExpired(input: $input) {\n    status\n  }\n}\n",
    "metadata": {}
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = 'bb66190e710994a94da5ac11881133a0';

module.exports = node;
